import React, {useEffect, useState} from 'react';
import { fetchJson, fetchJsonNoModals } from './fetch';
import {PubSub} from './weave/helpers.mjs';

class Button extends React.Component {
    render() { 
        var classes = "btn ";
        classes += this.props.classes;

        if(this.props.type) {
            var type = this.props.type;
        } else {
            var type = "button";
        }

        var onClick = this.props.onClick;
        if (this.props.close) {
            onClick = this.props.onClose;
        }

        return (
            <button className={classes} type={type} onClick={onClick} title={this.props.tooltip}>{this.props.text}</button>
        );
    }
}

class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: this.props.startOpen ? true : false,
            heading: null,
            message: null
        };
    }

    componentDidMount() {
        PubSub.sub(this.props.id, this.open.bind(this));
        PubSub.sub(this.props.id + "_close", this.close.bind(this));
        if (this.props.startOpen) {
            this.open(this.props.heading, this.props.message);
        }
    }

    componentWillUnmount() {
        PubSub.clearsub(this.props.id);
        PubSub.clearsub(this.props.id + "_close");
    }

    open(heading, message) {
        this.setState({
            active: true,
            heading: heading,
            message: message
        });
    }

    close() {
        PubSub.pub("onClose_" + this.props.id);

        this.setState({
            active: false
        });
    }

    closeCancel() {
        if (this.props.onCancelCallback) {
            this.props.onCancelCallback();
        }

        this.close();
    }

    getHeading() {
        return this.state.heading ? this.state.heading : this.props.heading;
    }

    getMessage() {
        return this.state.message ? this.state.message : this.props.message;
    }

    render() {
        var classes = "modal-container center";
        if (this.props.big) {
            classes += " big";
        }
        
        return (
            <dialog className={this.state.active?"active modal " + this.props.className:"modal " + this.props.className} id={this.props.id}>
                <div className="modal-overlay" onClick={this.closeCancel.bind(this)}></div>
                <div className={classes}>
                    <div className="modal-header">
                        {this.getHeading() && <h3>{this.getHeading()}</h3>}
                        <button className="btn btn-clear" type="button" aria-label="Close" onClick={this.closeCancel.bind(this)}><span className="visuallyHidden visually-hidden">Close</span></button>
                    </div>
                    {this.getMessage() && !this.props.body && <div className="modal-body">
                        <p>{this.getMessage()}</p>
                    </div>}
                    {this.props.body && <div className="modal-body">
                        {this.props.body}
                    </div>}
                    <div className="modal-footer">
                        <menu>
                            {this.props.buttons.map(b =>
                                <Button key={b.id} text={b.text} classes={b.classes} onClick={b.onClick} tooltip={b.tooltip} close={b.close} onClose={this.close.bind(this)} type={b.type} />
                            )}
                        </menu>
                    </div>
                </div>
            </dialog>
        );
    }
}

class ErrorNotification extends React.Component {
    render() { 
        const buttons = [
            {
                id: "1",
                text: "OK",
                close: true,
                classes: "btn-primary"
            }
        ];

        return (
            <Modal id="errorNotificationModal" heading={this.props.heading || "Error"} message={this.props.message} buttons={buttons} />
        );
    }
}

class ConfirmationModal extends React.Component {
    render() {
        const buttons = [
            {
                id: "1",
                text: this.props.confirmText ? this.props.confirmText : "Confirm",
                classes: "btn-primary",
                onClick: () => {
                    this.props.callback();
                    PubSub.pub(this.props.id + "_close");
                }
            },
            {
                id: "2",
                text: "Cancel",
                close: true,
                classes: "btn-light"
            }
        ];

        return (
            <Modal id={this.props.id} heading={this.props.heading} message={this.props.message} buttons={buttons} startOpen={this.props.startOpen} />
        );
    }
}

const EditEntityModal = ({id, heading, confirmText, route, editRoute, name, setName, callback, edit, error, setError}) => {
    const onSubmit = (e) => {
        if (!name) {
            setError("Please enter a name");
            return;
        }
        const form = document.getElementById(id+"_form");
        var formData = new FormData(form);
        var duplicateUrl = route+"/checkDuplicate";
        duplicateUrl += ("/" + edit);
        fetchJsonNoModals(duplicateUrl, formData).then(r => {
            var url = editRoute + "/" + edit;
            fetchJson(url, formData).then(r => {
                callback(r);
            });
            PubSub.pub(id + "_close");
        }).catch(() => {
            setError("That name is already in use");
        });

        e.preventDefault();
    }

    const buttons = [
        {
            id: "1",
            text: confirmText ? confirmText : "Confirm",
            classes: "btn-primary",
            onClick: onSubmit,
        },
        {
            id: "2",
            text: "Cancel",
            close: true,
            classes: "btn-light",
        }
    ];

    return <AddEditBody id={id} name={name} heading={heading} buttons={buttons} setName={setName} error={error} onSubmit={onSubmit} />
}

const AddEntityModal = ({id, heading, confirmText, route, callback, extraData}) => {
    const [name, setName] = useState("");
    const [error, setError] = useState("");

    const onSubmit = (e) => {
        if (!name) {
            setError("Please enter a name");
            return;
        }
        const form = document.getElementById(id+"_form");
        var formData = new FormData(form);
        for (const k in extraData) {
            formData.append(k, extraData[k]);
        }
        var duplicateUrl = route+"/checkDuplicate";
        fetchJsonNoModals(duplicateUrl, formData).then(r => {
            var url = route+"/add";
            fetchJson(url, formData).then(r => {
                callback(r);
            });
            PubSub.pub(id + "_close");
        }).catch(() => {
            setError("That name is already in use");
        });

        e.preventDefault();
    }

    const buttons = [
        {
            id: "1",
            text: confirmText ? confirmText : "Confirm",
            classes: "btn-primary",
            onClick: onSubmit,
            type: "submit",
        },
        {
            id: "2",
            text: "Cancel",
            close: true,
            classes: "btn-light",
        }
    ];

    return <AddEditBody id={id} name={name} heading={heading} buttons={buttons} setName={setName} error={error} onSubmit={onSubmit} />
}

const AddEditBody = ({id, name, heading, buttons, setName, error, onSubmit}) => {
    const body = <>
        <form id={id+"_form"} method="post" onSubmit={onSubmit}>
            <div className="form-split">
                <div className="col-1">&nbsp;</div>
                <div className="col-2">
                    <label className="form-label" htmlFor={id+"_name"}>Name:</label>
                </div>

                <div className="col-8">
                    <input className="form-input" id={id+"_name"} name="name" type="text" value={name} maxLength="30" onChange={(e) => {setName(e.target.value)}} required />
                </div>
                <div className="col-1">&nbsp;</div>
            </div>
        </form>
        <p className="error">{error}</p>
    </>

    return (
        <Modal id={id} heading={heading} body={body} buttons={buttons} />
    );
}

class LoadingNotification extends React.Component {
    render() {
        return (
            <Modal id="loadingNotification" heading="Loading..." buttons={[]} />
        );
    }
}

function notifyLoading(heading) {
    PubSub.pub("loadingNotification", heading);
}

function stopNotifyLoading() {
    PubSub.pub("loadingNotification_close");
}

function notifyError(heading, message) {
    PubSub.pub("errorNotificationModal", heading, message);
    return new Promise(resolve => {
        PubSub.sub("onClose_errorNotificationModal", function() {
            resolve();
        });
    });
}

function openModal(modalId, heading, message) {
    PubSub.pub(modalId, heading, message);
    return new Promise((resolve, reject) => {
        PubSub.sub(modalId + "_close", function() {
            resolve('done');
            //reject('error');
        });
    });

}

function closeModal(modalId) {
    PubSub.pub(modalId + "_close");
}

export {Modal, ConfirmationModal, ErrorNotification, LoadingNotification, AddEntityModal, EditEntityModal, notifyError, notifyLoading, stopNotifyLoading, openModal, closeModal};